import { FunctionComponent, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Spinner, Dropdown, DropdownOption } from "@volvo/vcdk-react";
import { DropdownChangeEvent } from "@volvo/vcdk";
import { useGetCurrenciesQuery } from '../../store/InvoiceApiSlice';
import { Currency } from '../../Types';

export const CurrencyDropdown = forwardRef((props, ref) => {
    const [value, setValue] = useState<string | undefined>(undefined);
    const {data: currencyList = [], isLoading, isSuccess, isError, error} = useGetCurrenciesQuery({});
    const [stateCurrencyList, setStateCurrencyList] = useState<Currency[]>([]);

    useImperativeHandle(ref, () => ({
        getCurrency: () => value
    }));

    useEffect(() => {
		if(isSuccess){
            setStateCurrencyList(currencyList.map((currency: Currency) => ({...currency})));
            if(currencyList.length > 0) setValue(currencyList[0].currencyID.toString());            
        }
	}, [isSuccess, currencyList]);

    if(isLoading) return <Spinner />
    return (<Dropdown onChange={(e: DropdownChangeEvent) => setValue(e.detail.value) } value={value} floatingLabel={false} size='small' style={{ width: 330, display: "inline-block" }}>
                {stateCurrencyList.map((currency: Currency) => (
                    <DropdownOption key={currency.currencyID} value={currency.currencyID.toString()}>
                        {currency.name}
                    </DropdownOption>
                ))}            
            </Dropdown>)
})